import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const GetQuickSearchDataQuery = graphql.persisted(
  "GetQuickSearchData",
  graphql(`
    query GetQuickSearchData($schoolYearId: ID!) {
      schoolYear(id: $schoolYearId) {
        id
        familyEnrollments {
          id
          family {
            id
            name
            slug
            guardians {
              person {
                id
                fullName
              }
            }
          }
          studentEnrollments {
            id
            person {
              id
              fullName
            }
          }
        }
      }
    }
  `)
);

export { GetQuickSearchDataQuery };

export function useQuickSearchQuery(schoolYearId: string | undefined) {
  return useQuery(GetQuickSearchDataQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: !schoolYearId,
  });
}
